module.exports = __webpack_public_path__ + "img/thanks1.0ec2eed8.svg";